const { Keywords } = require('../core/keywords');

/**
 * Supported Escape Characters:
 * \n - Newline
 * \t - Tab
 * \r - Carriage Return
 * \" - Double Quote
 * \' - Single Quote
 * \\ - Backslash
 */

module.exports = {
    [Keywords.PROGRAM_START]: 'أهلاً {{name}}',
    [Keywords.PROGRAM_END]: 'مع السلامة {{name}}',
    [Keywords.PRINT]: 'تكلم {{name}}',
    [Keywords.VARIABLE]: '{{name}} هذا هو',
    [Keywords.UNTIL]: 'حتى {{name}}',
    [Keywords.IF]: 'إذا {{name}}',
    [Keywords.ELSE]: 'وإلا {{name}}',
    [Keywords.FOR]: 'كرر {{name}}',
    [Keywords.BREAK]: 'توقف',
    [Keywords.CONTINUE]: 'استمر',
    [Keywords.TRUE]: 'صح',
    [Keywords.FALSE]: 'خطأ',
    [Keywords.AND]: 'و',
    [Keywords.OR]: 'أو',
    [Keywords.LENGTH]: 'طول',
    [Keywords.INPUT]: 'اسأل {{name}}'
};
